import { formatDuration } from "../time/index.js";
/**
 * **الرقمُ بوحدته — من موضعٍ واحد.**
 *
 * فالنسبةُ «85%»، والدقائقُ مدّةٌ تُقرأ («24 ساعة و32 دقيقة»)، والعددُ عدد. وكانت
 * اللوحةُ تكتب النسبةَ بعلامتها والدقائقَ رقماً عارياً — «متوسط الردّ على الإشارة
 * 1472» — ولوحةُ الأهداف تكتبها مرّةً ثانيةً بيدها. فصارت هنا وتقرؤها الاثنتان.
 */
export function formatMetricValue(value, unit, locale) {
    if (unit === "percent")
        return `${value}%`;
    if (unit === "minutes")
        return formatDuration(value, locale);
    return String(value);
}
//# sourceMappingURL=value.js.map